import { render, staticRenderFns } from "./ipImagesSwiper.vue?vue&type=template&id=446572e8&scoped=true&"
import script from "./ipImagesSwiper.vue?vue&type=script&lang=js&"
export * from "./ipImagesSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ipImagesSwiper.vue?vue&type=style&index=0&id=446572e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446572e8",
  null
  
)

export default component.exports